// Components/Auth/Unauthorized.js
import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => (
  <div className="unauthorized-container">
    <h2>Unauthorized Access</h2>
    <p>You don&apos;t have permission to access this page.</p>
    <Link to="/">Return to Home</Link>
  </div>
);

export default Unauthorized;
